import { createTheme } from '@mui/material/styles'

const MAIN_FONT =
  '"Rock Sans", "Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Tahoma, sans-serif'
const HEADING_FONT = '"Rock Serif", "Rock Sans", "Gotham Bold", "Trebuchet MS", sans-serif'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#430397', // Purple
      light: '#fe2f61', // Pink
      dark: '#2d0266',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#fe2f61', // Pink
      light: '#ff5c82',
      dark: '#d91649',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#000000',
      paper: '#0a0a0a',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0B0B0',
    },
  },
  typography: {
    fontFamily: MAIN_FONT,
    h1: {
      fontSize: '3rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 700,
      letterSpacing: '0.05em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
    body1: {
      fontSize: '1rem',
      letterSpacing: '0.02em',
    },
    body2: {
      fontSize: '0.875rem',
      letterSpacing: '0.02em',
    },
    button: {
      fontWeight: 600,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      fontFamily: HEADING_FONT,
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: '12px 24px',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderBottom: '1px solid #d51e47',
        },
      },
    },
  },
})

export default theme
